import SelectTypeAndLevel from './SelectTypeAndLevel';
import subRoutes from './Types';

export default {
  linkName: 'Integrations',
  path: '/hardware/integrations',
  exact: true,
  component: SelectTypeAndLevel,
  subRoutes,
  rootPath: { name: 'Hardware', uri: '/hardware' },
  subPath: [{ name: 'SelectTypeAndLevel' }],
};
